import {Model} from 'simpli-web-sdk'
import {HttpIgnore, ResponseFill} from 'simpli-web-sdk'

@HttpIgnore()
export default class RiskAreaRequest extends Model {
  readonly $name: string = 'RiskAreaRequest'

  @ResponseFill('cepInicial')
  cepInicial: string | null = null

  @ResponseFill('cepFinal')
  cepFinal: string | null = null
}
